import type { TourDef } from './index';

const a = (id: string): string => `[data-tour="${id}"]`;

/** First-run tour for `/invest` (register in tours/index.ts and set `tourId: 'invest'` on the route — see docs/proposals/agent-g.md). */
export const investTour: TourDef = {
  id: 'invest',
  steps: [
    { element: a('invest-summary'), popover: { title: 'Your portfolio at a glance', description: 'Market value, cost base and the unrealised gain — split into the part that already qualifies for the 12-month CGT discount and the part that doesn’t yet.' } },
    { element: a('invest-holdings-table'), popover: { title: 'Holdings', description: 'Sort any column, choose columns, and press Enter on a row to see its parcels, price history and income.' } },
    { element: a('invest-refresh'), popover: { title: 'Fresh prices', description: 'Fetch the latest closes. A “Stale” badge means a price is more than a few days old.' } },
    { element: a('invest-allocation'), popover: { title: 'Allocation', description: 'How your money is spread by asset class, sector and country.' } },
    { element: a('invest-nav'), popover: { title: 'Everything investing', description: 'Record trades, simulate a sale before you make it, log dividends and corporate actions, and compare performance with an ETF.' } },
  ],
};
